import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%2C%20vintage%20film%20projector%20beam%20cutting%20through%20darkness%2C%20golden%20warm%20light%2C%20dust%20particles%20in%20light%20beam%2C%20dramatic%20contrast%2C%20abstract%20artistic%20composition%2C%20film%20noir%20inspired%2C%20dark%20rich%20tones&width=1600&height=700&seq=hero-bg-tianmei&orientation=landscape"
        alt="天美影视 - 电影在线观看"
        title="天美影视电影大全 高清电影在线观看"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/50 to-background-950/90"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 w-full">
        <div className="text-center max-w-3xl mx-auto w-full">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-50 mb-4 leading-tight">
            天美影视电影大全，最新电影高清免费在线观看
          </h1>
          <p className="text-sm md:text-base text-foreground-400 mb-8 max-w-xl mx-auto leading-relaxed">
            不缓冲流畅追大片，免费在线看电影，高清电影大全在线看。海量电影资源，每日更新，尽在天美影视。
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/dongzuo"
              className="px-6 py-3 bg-primary-500 text-background-950 font-semibold rounded-full text-sm hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_0_30px_rgba(245,180,50,0.3)]"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观影
            </Link>
            <Link
              to="/category/juqing"
              className="px-6 py-3 bg-background-700/60 text-foreground-200 font-medium rounded-full text-sm hover:bg-background-600/60 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-600/50"
            >
              <i className="ri-film-line mr-2"></i>
              电影分类
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              i === 0 ? 'bg-primary-500 w-6' : 'bg-foreground-600/50'
            }`}
          ></div>
        ))}
      </div>
    </section>
  );
}